import { createExportReport } from 'shared/ui';
import { ExportReportShiftsModel } from '../../model';

export const createExportReportShifts = (model: ExportReportShiftsModel) => {
	const ExportReport = createExportReport(model);

	return ExportReport;
};
